import type {
	ITokenService,
	IUserStorageService,
} from "@/application/ports/services";
import type { IMonitoring } from "@/application/ports/IMonitoring";
import type { User } from "@/domain/user";

export function toSentryContext(user: User) {
	return {
		id: String(user.uuid ?? user.id),
		email: user.email,
		firstName: user.first_name ?? undefined,
		lastName: user.last_name ?? undefined,
	};
}

export function clearAuthData(
	tokenService: ITokenService,
	userStorageService: IUserStorageService,
	monitoring: IMonitoring,
): void {
	tokenService.removeToken();
	tokenService.removeRefreshToken();
	userStorageService.removeCurrentUser();
	monitoring.clearUserContext();
}
